import { FatorRedutor, HistoricoTranche, VigenciaFatorEcg, EventoDistribuicao, TipoEventoDistribuicao, FatorEcg, FatorReducaoEcg, LimiteContratacaoOperacao, PorteEmpresaClienteTrancheDTO, CicloDistribuicaoLimite } from './../../model/tranche.model';

import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';

import { FgiBackEndService } from '../fgi-back-end.service';
import { Tranche } from '../../model/tranche.model';
import { Observable } from 'rxjs';
import { blockUi, useCache, refreshCache } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ResultadoPaginado } from 'src/app/model/resultado';

@Injectable({
  providedIn: 'root'
})
export class TrancheService extends FgiBackEndService<Tranche> {

  private carregouTranches = false;
  private siglaModalidadeGarantia: string;

  // @Override (obrigado a sobrescrever. Nao faz sentido para o nosso caso.)
  getNewEntity() {
    return new Tranche();
  }

  // @Override (obrigado a sobrescrever. Nao faz sentido para o nosso caso.)
  protected getResourceURL(): string {
    return 'front/tranches';
  }

 public getTranches(): Observable<Tranche[]> {
    return this.http.get(`${this.BASE_URL}/`, this.carregouTranches ? useCache(): refreshCache())
    .pipe(map((tranches: any) => {
      for (let tranche of tranches) {
        this.siglaModalidadeGarantia = tranche.siglaModalidadeGarantia;
      }
      this.carregouTranches = true;
      return tranches;
    }),
      catchError((e) => this.handleError(e))) as Observable<Tranche[]>;
  }

  public getTrancheAtual(): Observable<Tranche> {
    return this.http.get(`${this.BASE_URL}/atual`, useCache()).pipe(map((tranche: any) => {
      this.siglaModalidadeGarantia = tranche.siglaModalidadeGarantia;
      this.carregouTranches = true;
      return tranche;
    }),
      catchError((e) => this.handleError(e))) as Observable<Tranche>;
  }

  public jaCarregouTranches(): boolean {
    return this.carregouTranches;
  }

  public siglaModalidadeGarantiaTranchesCarregadas(): string {
    return this.siglaModalidadeGarantia;
  }

  public atualizarTranche(id: number, dto: Tranche): Observable<any> {
    const options: any = blockUi();
    this.carregouTranches = false;
    return this.http.post(`${this.BASE_URL}/${id}/atualizar`, dto, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public buscarNumeroCestaMax(): Observable<any>{
    const options: any = blockUi();
    return this.http.get(`${this.BASE_URL}/ultimo-numero-tranche`, options).pipe(
      (catchError((e) => this.handleError(e)))) as Observable<any>;
  }

  public salvarTranche(dto: Tranche): Observable<any> {
    const options: any = blockUi();
    this.carregouTranches = false;
    return this.http.post(`${this.BASE_URL}/`, dto, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }
  public salvarFatorRedutor(id:number, dto: FatorRedutor): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/${id}/fatorRedutor`, dto, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }
  public salvarTaxaStopLoss(id:number, dto: FatorRedutor): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/${id}/taxaStopLoss`, dto, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }
  public salvarLimiteContratacaoBeneficiario(id:number, dto: FatorRedutor): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/${id}/limiteContratacaoBeneficiario`, dto, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }
  public salvarLimiteContratacaoOperacao(id:number, dto: FatorRedutor): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/${id}/limiteContratacaoOperacao`, dto, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }
  public salvarPrazoContratacao(id:number, dto: FatorRedutor): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/${id}/subtranchePrazoContratacao`, dto, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }
  public salvarEventoDistribuicao(id:number, dto: EventoDistribuicao): Observable<any> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/${id}/adicionarEventoDistribuicao`, dto, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }
  public salvarVigenciaFatorEcg(id:number, idVigenciaFatorEcg: number, dto: VigenciaFatorEcg): Observable<VigenciaFatorEcg[]> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/${id}/${idVigenciaFatorEcg}/adicionarVigenciaFatorEcg`, dto, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<VigenciaFatorEcg[]>;
  }
  public salvarNovaVigenciaFatorEcg(id:number, idUltimaVigenciaFatorEcg: number, dto: VigenciaFatorEcg): Observable<VigenciaFatorEcg[]> {
    const options: any = blockUi();
    dto.ideAnterior = idUltimaVigenciaFatorEcg;
    return this.http.post(`${this.BASE_URL}/${id}/adicionarNovaVigenciaFatorEcg`, dto, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<VigenciaFatorEcg[]>;
  }

  public buscarHistoricoTranche(idHistoricoTranche: number) : Observable<HistoricoTranche[]> {
    const options: any = blockUi();
    return this.http.get(`${this.BASE_URL}/historico/${idHistoricoTranche}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<HistoricoTranche[]>;
  }
  public buscarEventosDistribuicao(id: number) : Observable<EventoDistribuicao[]> {
    const options: any = blockUi();
    return this.http.get(`${this.BASE_URL}/${id}/eventoDistribuicao`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<EventoDistribuicao[]>;
  }

  public buscarVigenciasFatorEcg(id:number) : Observable<VigenciaFatorEcg[]> {
    const options: any = blockUi();
    return this.http.get(`${this.BASE_URL}/${id}/vigenciaFatorEcg`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<VigenciaFatorEcg[]>;
  }

  public buscarVigenciaFatorEcg(idFator:number) : Observable<FatorEcg[]> {
    const options: any = blockUi();
    return this.http.get(`${this.BASE_URL}/vigenciaFatorEcg/${idFator}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<FatorEcg[]>;
  }

  public excluirFatorEcg(id: number, idVigenciaFatorEcg: number): Observable<VigenciaFatorEcg[]> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/${id}/${idVigenciaFatorEcg}/excluirFatorEcg`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<VigenciaFatorEcg[]>;
  }

  public excluirEncerrarLimiteContratacaoOperacao(id: number, dto: LimiteContratacaoOperacao): Observable<LimiteContratacaoOperacao[]> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/${id}/excluirLimiteContratacaoOperacao`, dto, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<LimiteContratacaoOperacao[]>;
  }

  public calcularFatores(vigencias: FatorEcg[]): Observable<FatorEcg[]> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/calcularVigenciaFatorEcg`, vigencias, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<FatorEcg[]>;
  }

  public duplicarVigenciaFatorEcg(id:number, idVigenciaFatorEcg: number, dto: VigenciaFatorEcg): Observable<VigenciaFatorEcg[]> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/${id}/duplicarVigenciaFatorEcg/${idVigenciaFatorEcg}`, dto, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<VigenciaFatorEcg[]>;
  }

  public buscarFatorRedutorEcg(id:number) : Observable<FatorReducaoEcg[]> {
    const options: any = blockUi();
    return this.http.get(`${this.BASE_URL}/${id}/vigenciaFatorRedutorEcg`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<FatorReducaoEcg[]>;
  }

  public excluirFatorRedutorEcg(idFatorRedutorEcg: number, ideFatorAnterior: number) {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/${idFatorRedutorEcg}/excluirFatorRedutorEcg?ideFatorAnterior=${ideFatorAnterior ? ideFatorAnterior : ''}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public salvarNovoFatorRedutorEcg(id:number, idUltimoFatorRedutorEcg: number, dto: FatorReducaoEcg): Observable<FatorReducaoEcg[]> {
    const options: any = blockUi();
    dto.ideAnterior = idUltimoFatorRedutorEcg;
    return this.http.post(`${this.BASE_URL}/${id}/adicionarNovoFatorRedutorEcg`, dto, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<FatorReducaoEcg[]>;
  }

  public encerrarVigenciaFatorRedutorEcg(dto: FatorReducaoEcg): Observable<FatorReducaoEcg[]> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/${dto.id}/encerrarFatorRedutorEcg`, dto, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<FatorReducaoEcg[]>;
  }

  public buscarPorteBeneficiario(id: number, params?: any): Observable<ResultadoPaginado<PorteEmpresaClienteTrancheDTO>> {
    return this.http.get<ResultadoPaginado<PorteEmpresaClienteTrancheDTO>>(`${this.BASE_URL}/${id}/porte-beneficiario`,
      { params: params }).pipe(catchError((e) => this.handleError(e))) as Observable<any>;
  }

  public incluirPorte(id:number, dto: PorteEmpresaClienteTrancheDTO): Observable<PorteEmpresaClienteTrancheDTO> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/${id}/porte-beneficiario/incluir`, dto, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<PorteEmpresaClienteTrancheDTO>;
  }

  public excluirPorteBeneficiario(id: number): Observable<LimiteContratacaoOperacao[]> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/${id}/porte-beneficiario/excluir`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<LimiteContratacaoOperacao[]>;
  }

  public encerrarPorteBeneficiario(id: number, dto: LimiteContratacaoOperacao): Observable<LimiteContratacaoOperacao[]> {
    const options: any = blockUi();
    return this.http.post(`${this.BASE_URL}/${id}/porte-beneficiario/encerrar`, dto, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<LimiteContratacaoOperacao[]>;
  }

  buscarLimitesAdicionaisTranche(idTranche: number): Observable<any[]>{
    const options: any = blockUi();
    return this.http.get(`${this.BASE_URL}/${idTranche}/limiteAdicional`,options).pipe(catchError((e) => this.handleError(e))) as Observable<any>;;
  }
  
  public buscarCiclosMetaDescumprida(id: number, idEventoDistribuicao: number) : Observable<CicloDistribuicaoLimite[]> {
    const options: any = blockUi();
    return this.http.get(`${this.BASE_URL}/${id}/eventoDistribuicao/ciclosMetaDescumprida/${idEventoDistribuicao}`, options).pipe
      (catchError((e) => this.handleError(e))) as Observable<CicloDistribuicaoLimite[]>;
  }

}
